import { useEffect, useState } from "react";

/**
 * Determine if the browser satisfies the browserslist configuration.
 *
 * In order for this to function, ensure that the `<script />` tag is included
 * in your application. See [README.md](../README.md) for more information.
 * @returns {[boolean]}
 */
export const useIsBrowserSupported = (): [boolean] => {
  const [isBrowserSupported, setIsBrowserSupported] = useState(
    // Assume browser is supported unless it's explicitly not
    typeof window === "undefined" || window.isBrowserSupported !== false,
  );

  useEffect(() => {
    // eslint-disable-next-line @web-monorepo/no-setState-in-useEffect -- legitimate event listener: state is updated in response to external DOM event
    const handleEvent = (event: IsBrowserSupportedEvent) => setIsBrowserSupported(event.detail.isBrowserSupported);

    window.addEventListener("isbrowsersupported", handleEvent);
    return () => window.removeEventListener("isbrowsersupported", handleEvent);
  }, []);

  return [isBrowserSupported];
};
